import CommunityTalkForm from "@/pages/CommunityTalkForm";

export default function QuestionForm() {
  return <CommunityTalkForm intent="question" />;
}
